<template>
  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="backList">赠送活动管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>{{titleIndex}}</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns1">
        <li>
          <el-button
            @click="backList"
            type="primary"
          >返回活动列表</el-button>
        </li>
      </ul>
      <div class="contain_header1 clr">
        <el-form
          style="width:850px;"
          ref="form"
          :model="form"
          label-width="200px"
          :rules="addFormRule"
        >
          <el-form-item
            label="活动名称"
            prop="infoName"
          >
            <el-input
              v-model="form.infoName"
              placeholder="请输入活动名称"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="活动类型"
            prop="infoType"
          >
            <el-select v-model="form.infoType">
              <el-option
                v-for="option in typeOptions"
                :value="option.id"
                :key="option.id"
                :label="option.title"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="上架状态"
            prop="status"
          >
            <el-select v-model="form.status">
              <el-option
                v-for="option in statusOptions"
                :value="option.id"
                :key="option.id"
                :label="option.title"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="活动开始时间"
            prop="beginTime"
          >
            <el-date-picker
              v-model="form.beginTime"
              align="center"
              type="datetime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>

          <el-form-item
            label="活动结束时间"
            prop="endTime"
          >
            <el-date-picker
              v-model="form.endTime"
              align="center"
              type="datetime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>

          <el-form-item
            v-if="form.infoType == 2"
            label="满赠数量"
            prop="infoNum"
          >
            <el-input
              v-model="form.infoNum"
              placeholder="满足多少个赠送一个"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.infoType == 1"
            label="总赠送数量"
            prop="sendTotal"
          >
            <el-input
              v-model="form.sendTotal"
              placeholder="总赠送数量"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.infoType == 2"
            label="参与活动商品"
            prop="checkList"
          >
            <el-checkbox-group
              @change='changeGroup'
              v-model="form.checkList"
            >
              <el-checkbox
                @change="changeBox"
                :key="option.id"
                v-for="option in goodOptions"
                :label="option.id"
              >{{option.good_name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <div v-if="form.infoType == 2">
            <el-form-item
              v-for="(domain, index) in form.domains"
              :label="domain.goodName"
              :key="domain.id"
              :prop="'domains.' + index + '.id'"
              :rules="{
              required: true, message: '数量不能为空', trigger: 'blur'
            }"
            >
              <el-input
                style="width:200px;margin-right:20px"
                type="number"
                v-model="domain.value"
              ></el-input>
              <!-- <el-button @click.prevent="removeDomain(domain)" size="small">删除</el-button> -->
            </el-form-item>
          </div>

          <el-form-item
            v-if="form.infoType == 1"
            label="满足金额赠送"
            prop="infoMoney"
          >
            <el-input
              v-model="form.infoMoney"
              placeholder="满足多少钱，赠送一个大礼包"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.infoType == 1"
            label="大礼包名称"
            prop="goodName"
          >
            <el-input
              v-model="form.goodName"
              placeholder="大礼包商品名称，APP端会显示"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.infoType == 1"
            label="大礼包图片"
            prop="goodPic"
          >
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data="tokenData"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="form.goodPic"
                :src="form.goodPic"
                class="avatar"
              />
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
              <div
                slot="tip"
                class="el-upload__tip"
              >只能上传jpg/png文件，图片比例：1比1</div>
            </el-upload>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('form')"
              :loading="addLoading"
            >{{wordName}}</el-button>
            <el-button @click="resetForm('form')">重置</el-button>
            <el-button @click="backList">返回列表</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-main>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc.js";
var _ = require("lodash");
export default {
  name: "add_good",
  data() {
    return {
      typeOptions: [
        { title: "满金额赠送", id: "1" },
        { title: "满数量赠送", id: "2" }
      ],
      statusOptions: [
        { title: "待上架", id: "1" },
        { title: "上架中", id: "2" },
        { title: "下架", id: "3" }
      ],
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      options: [],
      good: null,
      wordName: "新增",
      titleIndex: "新增赠送活动",
      props: {
        value: "id",
        label: "type_name"
      },
      addFormRule: {
        infoName: [
          {
            required: true,
            message: "请输入活动名称",
            trigger: "blur"
          }
        ],
        beginTime: [
          {
            required: true,
            message: "请选择活动开始时间",
            trigger: "blur"
          }
        ],
        endTime: [
          {
            required: true,
            message: "请选择活动结束时间",
            trigger: "blur"
          }
        ],
        infoType: [
          {
            required: true,
            message: "请选择活动类型",
            trigger: "blur"
          }
        ],
        status: [
          {
            required: true,
            message: "请选择活动上架状态",
            trigger: "blur"
          }
        ]
      },
      addLoading: false,
      goodOptions: [],
      form: {
        domains: [],
        checkList: [],
        sendTotal: null,
        infoName: null,
        beginTime: null,
        endTime: null,
        infoType: "1",
        status: "1",
        goodPic: null,
        goodIdList: null,
        goodName: null,
        infoNum: null,
        infoMoney: null,
        id: null
      }
    };
  },
  mounted(e) {
    //初始化表单
    var that = this;
    var good =
      this.$route.query.activity &&
      this.$route.query.activity != null &&
      this.$route.query.activity != "" &&
      this.$route.query.activity.id != null
        ? this.$route.query.activity
        : null;
    this.good = good;
    API.get_all_good_name({ token: localStorage.getItem("api_token") })
      .then(
        function(result) {
          if (result.key == 1000) {
            that.goodOptions = result.result.list;
          } else if (result.key == 1001) {
            bus.$emit("goto", "/login");
          } else {
            that.$message.error({
              showClose: true,
              message: result.message || "登录失败",
              duration: 2000
            });
          }
        },
        function(err) {
          that.loading = false;
          console.error(err);
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        that.loading = false;
        console.error(error);
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    if (good != null) {
      that.wordName = "修改";
      that.titleIndex = "修改赠送活动";
      that.form.id = good.id;
      that.form.infoName = good.info_name;
      this.form.infoType = good.info_type.toString();
      that.form.beginTime = new Date(good.begin_time);
      that.form.endTime = new Date(good.end_time);
      that.form.goodPic = good.good_pic;
      that.form.goodIdList = good.good_id_list;
      that.form.goodName = good.good_name;
      this.form.infoNum = good.info_num;
      that.form.infoMoney = good.info_money;
      that.form.status = good.status.toString();
      if (good.good_id_list != null && good.good_id_list != "") {
        that.form.checkList = good.good_id_list.split(",");
        for (var i = 0; i < that.form.checkList.length; i++) {
          that.form.checkList[i] = parseInt(that.form.checkList[i]);
        }
        if (good.send_num_list && good.send_num_list != null && good.send_num_list != '')
        {
          that.form.domains = JSON.parse(good.send_num_list);
        } else {
          that.form.domains = [];
        }
      }
    } else {
      that.form.status = "1";
      that.wordName = "立即创建";
    }
  },
  computed: {},
  methods: {
    changeGroup(e) {
      console.info(e);
      var list = [];
      for (var j = 0; j < e.length; j++) {
        for (var i = 0; i < this.goodOptions.length; i++) {
          if (e[j] == this.goodOptions[i].id) {
            list.push({
              goodName: this.goodOptions[i].good_name,
              id: this.goodOptions[i].id
            });
          }
        }
      }

      for (var j = 0; j < this.form.domains.length; j++) {
        var has = false;
        for (var i = 0; i < list.length; i++) {
          if (list[i].id == this.form.domains[j].id) {
            has = true;
          }
        }
        if (!has) {
          this.form.domains.splice(j, 1);
        }
      }

      for (var j = 0; j < list.length; j++) {
        var has = false;
        for (var i = 0; i < this.form.domains.length; i++) {
          if (list[j].id == this.form.domains[i].id) {
            has = true;
          }
        }
        if (!has) {
          this.form.domains.push(list[j]);
        }
      }
    },
    changeBox(e, f) {
      console.info(f);
    },
    removeDomain(item) {
      for (var j = 0; j < this.form.domains.length; j++) {
        if (item.id == this.form.domains[j].id) {
          this.form.domains.splice(j, 1);
        }
      }
    },
    addDomain() {
      this.form.domains.push({
        value: "",
        key: Date.now()
      });
    },
    backList() {
      this.$router.push({
        path: "/send_activity_list"
      });
    },
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.goodPic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    beforeAvatarUpload: function(e) {},
    onSubmit() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.infoType == 2) {
            for (var j = 0; j < this.form.domains.length; j++) {
              if (
                !this.form.domains[j].value ||
                this.form.domains[j].value == null ||
                this.form.domains[j].value == ""
              ) {
                that.$message.error({
                  showClose: true,
                  message: "请填写参与商品赠送数量",
                  duration: 2000
                });
                return;
              } else {
                this.form.domains[j].value = parseInt(
                  this.form.domains[j].value
                );
              }
            }
            that.form.sendNumList = JSON.stringify(that.form.domains);
          } else {
            if (
              !this.form.sendTotal ||
              this.form.sendTotal == null ||
              this.form.sendTotal == ""
            ) {
              that.$message.error({
                showClose: true,
                message: "请填写总赠送数量",
                duration: 2000
              });
              return;
            }
          }
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          if (that.form.infoType == 1) {
            if (
              !that.form.goodName ||
              that.form.goodName == null ||
              that.form.goodName == ""
            ) {
              that.$message.error({
                showClose: true,
                message: "请填写大礼包名称",
                duration: 2000
              });
              return;
            }
            if (
              !that.form.goodPic ||
              that.form.goodPic == null ||
              that.form.goodPic == ""
            ) {
              that.$message.error({
                showClose: true,
                message: "请上传大礼包图片",
                duration: 2000
              });
              return;
            }
            if (
              !that.form.infoMoney ||
              that.form.infoMoney == null ||
              that.form.infoMoney == ""
            ) {
              that.$message.error({
                showClose: true,
                message: "请填写满足赠送金额",
                duration: 2000
              });
              return;
            }
          }
          if (that.form.infoType == 2) {
            if (that.form.checkList.length == 0) {
              that.$message.error({
                showClose: true,
                message: "请选择参与活动的商品",
                duration: 2000
              });
              return;
            } else {
              var names = [];
              for (var i = 0; i < that.form.checkList.length; i++) {
                for (var j = 0; j < that.goodOptions.length; j++) {
                  if (
                    parseInt(that.form.checkList[i]) ==
                    parseInt(that.goodOptions[j].id)
                  ) {
                    names.push(that.goodOptions[j].good_name);
                  }
                }
              }
              para.goodIdList = that.form.checkList.join(",");
              para.goodIdName = names.join(",");
            }
            if (
              !that.form.infoNum ||
              that.form.infoNum == null ||
              that.form.infoNum == ""
            ) {
              that.$message.error({
                showClose: true,
                message: "请填写满足赠送数目",
                duration: 2000
              });
              return;
            }
          }
          para.beginTime = that.form.beginTime.getTime();
          para.endTime = that.form.endTime.getTime();
          that.addLoading = true;
          API.do_up_send_ac(para)
            .then(
              function(result) {
                that.addLoading = false;
                if (result.key == 1000) {
                  if (para.id) {
                    that.$message.success({
                      showClose: true,
                      message: "修改成功",
                      duration: 1500
                    });
                  } else {
                    that.$message.success({
                      showClose: true,
                      message: "创建成功",
                      duration: 1500
                    });
                  }

                  // resetForm();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    jumpTo(url) {
      this.defaultActiveIndex = url;
      this.$router.push(url); //用go刷新
    },
    resetForm() {
      let that = this;
      that.$refs["form"].resetFields();
    }
  }
};
</script>

<style>
.area-select .area-selected-trigger {
  padding: 0px 20px 7px 12px;
  line-height: 40px;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}
.cont_btns1 {
  float: left;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns1 li {
  display: inline-block;
}
.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}

.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}

.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}

.contain_div {
  margin: 20px;
}

.contain_header1 {
  background-color: #fff;
  padding: 40px 0 20px 40px;
  /* margin-bottom: 20px; */
}

.area-select {
  height: 40px;
}

.area-select-wrap .area-select {
  margin-left: 0px !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/addOrEditSendActivity.vue